import { Badge } from "@/components/ui";
import { BadgeProps } from "@/components/ui/badge";

import { formatToHumanReadable } from "@/lib/format-data";
import { cx } from "@/lib/tailwind-utils";

import { ChargeStatus } from "@/types/enums";

export const ChargeBadge = ({
  status,
  className,
}: {
  status: ChargeStatus;
  className?: string;
}) => {
  let variant: BadgeProps["variant"] = "default";

  switch (status) {
    case ChargeStatus.EXTERNAL_SETTLEMENT:
    case ChargeStatus.PAID:
      variant = "success";
      break;
    case ChargeStatus.OUTSTANDING:
    case ChargeStatus.PAYMENT_PLAN:
      variant = "neutral";
      break;
    case ChargeStatus.REFUNDED:
      variant = "warning";
      break;
    case ChargeStatus.VOID:
    case ChargeStatus.WRITE_OFF:
    case ChargeStatus.CHARGEBACK:
    case ChargeStatus.COLLECTIONS:
      variant = "error";
      break;
    default:
      variant = "default";
      break;
  }

  return (
    <Badge variant={variant} className={cx("font-normal", className)}>
      {formatToHumanReadable(status)}
    </Badge>
  );
};
